export default "__VITE_ASSET__nP8vXbN00dgA0dcDrP5Aiw__";